import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {ConstantService} from '../../constant/constant.service';
import 'rxjs/add/operator/map';
import * as mime from 'mime-types';

@Injectable({
  providedIn: 'root'
})
export class LoanService {

  constructor(
    private constantService: ConstantService,
    private http: HttpClient
  ) {
  }

  get(param: Array<object>) {
    if (!param.length) return this.http.get(this.constantService.getUrl(this.constantService.LOANS));
    else return this.http.get(this.constantService.getUrlByQuery(this.constantService.LOANS, param));
  }

  loanDetail(id) {
    return this.http.get(this.constantService.getUrl(`${this.constantService.LOANAPPLICANT}/${id}`));
  }

  getTermsAndConditionsTemplate(token) {
    return this.http.get(this.constantService.getUrl(`${this.constantService.BITLY}/loans/${token}/termsAndConditionsContent`));
  }

  getTermsAndConditionsContent(id) {
    return this.http.get(this.constantService.getUrl(`${this.constantService.LOANS}/${id}/termsAndConditionsContent`));
  }

  loans(id) {
    return this.http.get(this.constantService.getUrl(`${this.constantService.LOANS}/${id}`));
  }

  loanDetails(token) {
    return this.http.get(this.constantService.getUrl(`${this.constantService.BITLY}/loans/${token}/details`),
      {headers: {passErrorBack: 'true'}});
  }

  paymentDetails(token) {
    return this.http.get(this.constantService.getUrl(`${this.constantService.BITLY}/payment/${token}/details`));
  }

  initiateInsuranceAPI(token, loanId) {
    return this.http.post(this.constantService.getUrl(`${this.constantService.BITLY}/loans/${token}/init/careInsuranceAPI`), { loanId : loanId });
  }

  paymentSchedule(token, insurance) {
    let params = new HttpParams().set('insurance', insurance ? 'true' : 'false');
    return this.http.get(this.constantService.getUrl(`${this.constantService.BITLY}/loans/${token}/schedules`), {params: params});
  }

  payment(token, body) {
    return this.http.put(this.constantService.getUrl(`${this.constantService.BITLY}/loans/${token}/payment`), body);
  }

  getPaymentAmount(token, body) {
    return this.http.post(this.constantService.getUrl(`${this.constantService.BITLY}/loans/${token}/payment`),body);
  }

  skipPayment(token) {
    return this.http.put(this.constantService.getUrl(`${this.constantService.BITLY}/loans/${token}/skipProcessingFeePayment`), null);
  }

  eNach(token, body) {
    return this.http.put(this.constantService.getUrl(`${this.constantService.BITLY}/loans/${token}/autoDebt`), body);
  }
  
  captureAutoDebt(token, body) {
    return this.http.put(this.constantService.getUrl(`${this.constantService.BITLY}/loans/${token}/captureAutoDebt`), body);
  }

  skipEnach(token) {
    return this.http.put(this.constantService.getUrl(`${this.constantService.BITLY}/loans/${token}/skipAutoDebit`), null);
  }

  documents(body, token, headerData) {
    return this.http.put(this.constantService.getUrl(`${this.constantService.BITLY}/loans/${token}/documents`), body, {
      headers: headerData
    });
  }

  kyc(body, token) {
    let formData = new FormData();
    formData.append('aadhar', body.aadhar);
    formData.append('password', body.password);
    formData.append('offlineKYC', body.offlineKYC);

    return this.http.put(this.constantService.getUrl(`${this.constantService.BITLY}/loans/${token}/kyc`), formData);
  }

  documentsSmall(body, token, headerData) {
    return this.http.put(this.constantService.getUrl(`${this.constantService.BITLY}/loans/${token}/documents/small`), body, {
      headers: headerData
    });
  }

  getTermAndCondLetterPathS3(id) {
    return this.http.get(this.constantService.getUrl(this.constantService.APPLICATION + `/${id}/termsandCondition/signed`));
  }

  getWelcomeLetterPathS3(id) {
    return this.http.get(this.constantService.getUrl(this.constantService.APPLICATION + `/${id}/welcomeLetter/signed`));
  }

  getInsuranceCoverNotePathS3(id) {
  return this.http.get(this.constantService.getUrl(this.constantService.APPLICATION + `/${id}/insurance/cover/signed`));
  }
  
  signup(body, token) {
    return this.http.put(this.constantService.getUrl(`${this.constantService.BITLY}/loans/${token}/signup`), body);
  }

  loanInit(token, body) {
    return this.http.put(this.constantService.getUrl(`${this.constantService.BITLY}/loans/${token}/init`), body);
  }

  loanAcceptingTermsConditions(token, body) {
    return this.http.put(this.constantService.getUrl(`${this.constantService.BITLY}/loans/${token}/tc`), body);
  }

  paymentMeta(token) {
    return this.http.get(this.constantService.getUrl(`${this.constantService.BITLY}/loans/${token}/paymentMeta`));
  }

  digioPaymentMeta(token, mandateType) {
    return this.http.get(this.constantService.getUrl(`${this.constantService.BITLY}/loans/${token}/digio/paymentMeta`), {params : {"mandateType":mandateType}});
  }
  
  digioMandateStatus(token) {
    return this.http.get(this.constantService.getUrl(`${this.constantService.BITLY}/loans/${token}/digio/mandateStatus`));
  }

  nupayPaymentMeta(token, body) {
    return this.http.post(this.constantService.getUrl(`${this.constantService.BITLY}/loans/${token}/nupay/paymentMeta`), body );
  }

  loanStatus(params?: any) {
    return this.http.get(this.constantService.getUrl(this.constantService.LOANS), {
      params: params,
      observe: 'response'
    }).map((resp: any) => {
      let count = resp.headers.get('X-Total-Count');
      return {count: parseInt(count), data: resp.body.data};
    });
  }

  applicationStatus(params?: any) {
    return this.http.get(this.constantService.getUrl(this.constantService.LOANAPPLICANT), {
      params: params,
      observe: 'response'
    }).map((resp: any) => {
      let count = resp.headers.get('X-Total-Count');
      return {count: parseInt(count), data: resp.body.data};
    });
  }

  profile() {
    return this.http.get(this.constantService.getUrl(`${this.constantService.CUSTOMERS}/me`));
  }

  profileUpdate(body) {
    let formData = new FormData();
    for (let field in body) {
      if (field === 'images') {
        Array.from(body['images']).forEach((o: any) => {
          formData.append('images', o, o.name);
        });
      } else {
        formData.append(field, body[field]);
      }
    }
    return this.http.put(this.constantService.getUrl(`${this.constantService.CUSTOMERS}/me`), formData);
  }

  putChangePassword(body) {
    return this.http.put(this.constantService.getUrl(`${this.constantService.CUSTOMERS}/me/changePassword`), body);
  }

  sendPhotoLink(token) {
    return this.http.get(this.constantService.getUrl(`${this.constantService.BITLY}/loans/${token}/sendPhotoLink`));
  }

  uploadPhoto(token, body) {
    return this.http.put(this.constantService.getUrl(`${this.constantService.BITLY}/loans/${token}/documents/photo`), body);
  }

  payEMI(loanID, body) {
    return this.http.post(this.constantService.getUrl(`${this.constantService.LOANS}/${loanID}/payment/emi`), body);
  }

  showEMI(loanID) {
    return this.http.get(this.constantService.getUrl(`${this.constantService.LOANS}/${loanID}/payment/emi`));
  }

  showEMIAnonymous(loanToken) {
    return this.http.get(this.constantService.getUrl(`${this.constantService.BITLY}/EMIPayment/${loanToken}`));
  }

  payEMIAnonymous(loanToken, body) {
    return this.http.post(this.constantService.getUrl(`${this.constantService.BITLY}/EMIPayment/${loanToken}`), body);
  }

  getPathToInvoice(id) {
    return this.http.get(this.constantService.getUrl(this.constantService.APPLICATION + `/${id}/invoice/signed`));
  }

  getAddressProofPathS3(id) {
    return this.http.get(this.constantService.getUrl(this.constantService.APPLICATION + `/${id}/addressProof/signed`));
  }

  getPathToCoverNoteS3(id) {
    return this.http.get(this.constantService.getUrl(this.constantService.APPLICATION + `/${id}/insurance/cover/signed`));
  }

  getIdProofPathS3(id) {
    return this.http.get(this.constantService.getUrl(this.constantService.APPLICATION + `/${id}/idProof/signed`));
  }

  putCancelApplication(token) {
    return this.http.put(this.constantService.getUrl(this.constantService.BITLY + `/loans/${token}/cancel`), null);
  }

  uploadAddressProof(id, file) {
    let formData = new FormData();
    formData.append('addressProof', file.file, `file.${mime.extension(file.type)}`);
    formData.append('type', file.type);
    return this.http.put(this.constantService.getUrl(this.constantService.LOANS + `/${id}/upload/addressProof`), formData);
  }

  getEnach(token) {
    return this.http.get(this.constantService.getUrl(`${this.constantService.BITLY}/loans/${token}/autoDebit/info`));
  }

  registerEnach(token, body) {
    return this.http.put(this.constantService.getUrl(`${this.constantService.BITLY}/loans/${token}/autoDebit/register`), body);
  }

  getDeviceDetails(loanId) {
    return this.http.get(this.constantService.getUrl(`${this.constantService.LOANS}/${loanId}/deviceDetails`));
  }

  sendReEkycRequest(token) {
    return this.http.post(this.constantService.getUrl(`${this.constantService.BITLY}/ekyc/${token}/reekyc/register`), null);
  }

  sendEkycRequest(token) {
    return this.http.post(this.constantService.getUrl(`${this.constantService.BITLY}/loans/${token}/ekyc/register`), null);
  }

  sendAvanseEkycRequest(token) {
    return this.http.post(this.constantService.getUrl(`${this.constantService.BITLY}/loans/${token}/avanseEkyc/register`), null);
  }

  updateEkycResponse(token, body) {
    return this.http.post(this.constantService.getUrl(`${this.constantService.BITLY}/loans/${token}/ekyc/update`), body);
  }

  updateReEkycResponse(token, body) {
    return this.http.post(this.constantService.getUrl(`${this.constantService.BITLY}/ekyc/${token}/reekyc/update`), body);
  }


  checkEkycStatus(token, ekycId) {
    return this.http.post(this.constantService.getUrl(`${this.constantService.BITLY}/loans/${token}/ekyc/check`), { eKycRequestId : ekycId });
  }

  checkAvanseEkycStatus(token) {
    return this.http.get(this.constantService.getUrl(`${this.constantService.BITLY}/loans/${token}/avanseEkyc/check`), {});
  }

  sendeSignRequest(token) {
    return this.http.post(this.constantService.getUrl(`${this.constantService.BITLY}/loans/${token}/eSign/tandc/register`), null);
  }

  sendSecondeSignRequest(token) {
    return this.http.post(this.constantService.getUrl(`${this.constantService.BITLY}/esign/${token}/second/tandc/register`), null);
  }

  sendeAggregatorRequest(token) {
    return this.http.post(this.constantService.getUrl(`${this.constantService.BITLY}/loans/${token}/aggregator/register`), {});
  }

  updateeSignResponse(token, body) {
    return this.http.post(this.constantService.getUrl(`${this.constantService.BITLY}/loans/${token}/eSign/tandc/update`), body);
  }

  updateSecondeSignResponse(token, body) {
    return this.http.post(this.constantService.getUrl(`${this.constantService.BITLY}/esign/${token}/second/tandc/update`), body);
  }

  updateAggregatorResponse(token, body) {
    return this.http.post(this.constantService.getUrl(`${this.constantService.BITLY}/loans/${token}/aggregator/update`), body);
  }

  getTermsAndConditionsLetterPdf(token) {
    return this.http.get(this.constantService.getUrl(`${this.constantService.BITLY}/loans/${token}/termsOfService`));
  }

  getSecondTermsAndConditionsLetterPdf(token) {
    return this.http.get(this.constantService.getUrl(`${this.constantService.BITLY}/esign/${token}/second/termsOfService`));
  }

  getBankList(token) {
    return this.http.post(this.constantService.getUrl(`${this.constantService.BITLY}/loans/${token}/banklist`), {});
  }

  getTenureList(loanAmount){
    return this.http.get(this.constantService.getUrlByQuery(`${this.constantService.BRANCHES}/me/tenures`, [{
        name: 'amount',
        value: loanAmount
    }]));
  }
 
  cancelApplication(id, body){
      return this.http.put(this.constantService.getUrl(`${this.constantService.APPLICATION}/${id}/cancel`), body);
  }

  reviewApplication(id, body){
    return this.http.put(this.constantService.getUrl(`${this.constantService.APPLICATION}/${id}/review`), body);
  }

  getSecondMandate(token) {
    return this.http.get(this.constantService.getUrl(`${this.constantService.BITLY}/mandate/${token}/secondMandate/info`));
  }

  getSecondEsign(token) {
    return this.http.get(this.constantService.getUrl(`${this.constantService.BITLY}/esign/${token}/secondEsign/info`));
  }

  getSecondEkyc(token) {
    return this.http.get(this.constantService.getUrl(`${this.constantService.BITLY}/ekyc/${token}/secondEkyc/info`));
  }

  registerSecondMandate(token, body) {
    return this.http.put(this.constantService.getUrl(`${this.constantService.BITLY}/mandate/${token}/secondMandate/register`), body);
  }

  checkFinvuStatus(token) {
    return this.http.get(this.constantService.getUrl(`${this.constantService.BITLY}/loans/${token}/checkConsentStatus`));
  }

  getBcKFS(token) {
    return this.http.get(this.constantService.getUrl(`${this.constantService.BITLY}/loans/${token}/bcKFS`));
  }
  
}
